var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.StatelessTags,{attrs:{"value":_setup.valueArray,"placeholder":_setup.props.placeholder},on:{"input":_setup.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }